module.exports = __webpack_public_path__ + "img/visage.b9f63492.png";